module.exports = __webpack_public_path__ + "img/palermo-enna.141381a0.png";